import { createElement as t } from "../dom/index.js";
var e = function e() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : global.location;
  return "string" == typeof e ? t("a", {
    href: e
  }).pathname : e.pathname;
};
export { e as getRelativeUrl };